import React, { useEffect } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { filterHistoryCreate } from "redux/actions/filters/filterHistory";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { LocaleCurrency } from "helpers/Locale";

import DataTable from "components/dataTable/DataTable";
import "./payoutsTable.scss";
import { ITransactionList } from "pages/secure/facility/settings/payouts/PayoutsInfo";
import { Badge } from "components/badge/Badge";

type TTransactionsTableProps = {
  /** Passing undefined triggers Spin component */
  payOuts: ITransactionList;
  tableLimit: number;
  tableOffset: number;
  handleTableOffset: (direction: "prev" | "next") => void;
  showIcPlusBreakdown?: boolean;
  // handleTableNavigation?: (transaction_id: number) => void;
};

const OFFSET_HISTORY_KEY = "facility_payout_offset";
export default function TransactionsTable(props: TTransactionsTableProps) {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const filterHistoryStore = useAppSelector(store => store.filterHistoryStore);

  useEffect(() => {
    if (filterHistoryStore[OFFSET_HISTORY_KEY] === undefined) {
      dispatch(filterHistoryCreate(OFFSET_HISTORY_KEY));
    }
  }, []);

  const showIcPlusBreakdown = props.showIcPlusBreakdown ?? false;

  return (
    <DataTable
      className="transactions-table"
      columns={[
        { label: t("Amount") },
        ...(showIcPlusBreakdown
          ? [{ label: t("Platform Fee") }, { label: t("Network Cost") }]
          : []),
        { label: t("Fee") },
        { label: t("Net") },
        { label: t("Currency") },
        { label: t("Processed at") },
        { label: t("Available on") },
        { label: "" }, // Transaction status (for displaying if its a refund transaction)
      ]}
      loading={props.payOuts?.transactions === null}
      footer={
        props.payOuts?.transactions?.length > props.tableLimit
          ? {
              tableLimit: props.tableLimit,
              tableOffset: props.tableOffset,
              disableNextOffset:
                !props.payOuts.transactions || !(props.payOuts.transactions?.length === props.tableLimit),
              handleTableOffset: props.handleTableOffset,
            }
          : null
      }
    >
      {props.payOuts?.transactions?.map((transaction, index) => {
        const refund = transaction?.source_type === "refund" || transaction?.source_type === "account_refund" || transaction?.source_type === "deposit_refund";
        return (
        <tr key={index}>
          <td>
            <LocaleCurrency currency={transaction.currency} amount={refund ? transaction?.amount * -1 : transaction.amount} />
          </td>
          {showIcPlusBreakdown ? (
            <>
              <td>
                <LocaleCurrency currency={transaction.currency} amount={transaction.platform_fee ?? 0} />
              </td>
              <td>
                <LocaleCurrency currency={transaction.currency} amount={transaction.network_cost_fee ?? 0} />
              </td>
            </>
          ) : null}
          <td>
            <LocaleCurrency currency={transaction.currency} amount={transaction.fee} />
          </td>
          <td>
            <LocaleCurrency currency={transaction.currency} amount={refund ? transaction?.net * -1 : transaction.net} />
          </td>
          <td>{transaction.currency}</td>
          <td>{moment(transaction.processed_at).format("LLL")}</td>
          <td>{transaction.available_on}</td>
          <td>{refund ? <Badge type="gray" size="medium">{t("Refund")}</Badge> : null}</td>
        </tr>
        );
    })}
    </DataTable>
  );
}
